module.exports = __webpack_public_path__ + "static/media/ritualbanners_sm3.e32f3728.png";